import { Map } from '../../../Common/Charts/Map';
import { useMappingChartsDataContext } from './hooks/useMappingChartsDataContext';

const RegistersHouseHoldByCoordinates = () => {
    const { chartData } = useMappingChartsDataContext();

    return (
        <Map chartData={chartData.registersHouseHoldByCoordinates} zoom={8} />
    );
};

export default RegistersHouseHoldByCoordinates;
